var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isError ? _c('b-row', {
    staticClass: "justify-content-center mt-2"
  }, [_c('b-col', {
    attrs: {
      "lg": "10"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": "",
      "dismissible": ""
    }
  }, [_vm._v(" Opps .. Something is wrong ")])], 1)], 1) : _vm._e(), _c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Category BISAC',
        to: {
          name: 'category-bisac'
        }
      }, {
        label: 'Edit'
      }],
      "title": "Edit Category BISAC"
    }
  }), _c('div', {
    staticClass: "bg-white w-full rounded-lg mt-4 mb-3 px-4 py-2.5"
  }, [_c('h4', {
    staticClass: "font-bold text-xl py-2.5"
  }, [_vm._v("Edit Category BISAC")]), _c('div', {
    staticClass: "w-1/2 flex-col"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Category BISAC Code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }],
    staticClass: "px-2.5 py-2.5 border rounded-lg w-full",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "type category bisac code.."
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Category BISAC Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    staticClass: "px-2.5 py-2.5 border rounded-lg w-full",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "type category bisac name.."
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mt-3 mb-4"
  }, [_c('t-checkbox', {
    attrs: {
      "type": "checkbox",
      "id": "is_active"
    },
    model: {
      value: _vm.is_active,
      callback: function ($$v) {
        _vm.is_active = $$v;
      },
      expression: "is_active"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "is_active"
    }
  }, [_vm._v("Is Active")])], 1), _c('div', {
    staticClass: "flex justify-start pb-3"
  }, [_c('button', {
    staticClass: "bg-blue-700 text-white rounded-lg px-3 py-2",
    on: {
      "click": _vm.updateCategoryBisac
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "bg-white text-gray-500 rounded-lg border px-3 py-2 ml-4",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }